import { render, staticRenderFns } from "./ContactRep.vue?vue&type=template&id=67289378&scoped=true&"
import script from "./ContactRep.vue?vue&type=script&lang=js&"
export * from "./ContactRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67289378",
  null
  
)

export default component.exports